<template>
  <div
    id="salesDisabledMessageDialog"
    @click="closeModal"
    class="sale-options modal fade"
    data-backdrop="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content p-2">
        <button type="button"
                class="close location-close"
                data-dismiss="modal"
                aria-label="Close">
          <font-awesome-icon :icon="[ 'fas', 'times' ]" />
        </button>
        <div class="modal-body text-center">
          <h5 class="text-center"></h5>
          <p>
            Si tenés un comercio y querés vender online y recibir el dinero en MercadoPago por favor contactate a
            <a href="mailto:ventas@maspocovendo.com">ventas@maspocovendo.com para activar tu marketplace.</a>
          </p>
          <div class="row">

            <div class="col-12 col-sm-6 offset-sm-3">
              <div class="form-group px-sm-0 pt-3">
                <SquaredButton
                  styleType="primary"
                  label="Cerrar" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {api, urls} from '@/api'
import { cleanAmountInput, validPriceAmount, cleanIntegerInput } from '@/helpers'
export default {
  data () {
    return {
      item: {},
      step: 1
    }
  },
  methods: {

    closeModal (e) {
      this.close()
      if (e.target === this.$el) {
        this.close()
      } else {
        e.stopPropagation()
      }
    },

    close () {
      $(this.$el).modal('hide')
    },

  },
}
</script>

<style>
  #salesDisabledMessageDialog{
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/SalesDisabledMessage.vue